import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CustomerOrderService {
  http = inject(HttpClient);

  public getApiPublicCustomerOrder(customerOrderId: string, isInternalUser: boolean): Observable<any> {
    let params = new HttpParams();

    if (isInternalUser) {
      params = params.append('isInternalUser', true);
    }

    return this.http.get(`/api/v1/public/customer-order/${customerOrderId}`, { params: params });
  }

  public getReachDateDispute(public_id: any): Observable<any> {
    return this.http.get(`/api/v1/public/reach-date-dispute/${public_id}`);
  }

  public postReachDateDispute(public_id: any): Observable<any> {
    return this.http.post(`/api/v1/public/reach-date-dispute`, public_id);
  }
}
